'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _every2 = require('./internal/_every');

var _every3 = _interopRequireDefault(_every2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns `true` if **all** items in `subject` match `predicate`.
 *
 * @example
 * const alwaysBlue = every(v => v === 'blue');
 *
 * alwaysBlue(List.of('blue', 'blue')) === true;
 * alwaysBlue(List.of('red', 'blue')) === false;
 *
 * @param  {Function} predicate returns `true` if item is a match.
 * @param  {Iterable} subject
 * @return {bool}
 */
exports.default = (0, _curry2.default)(_every3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/every.js
// module id = 349
// module chunks = 0 1